import React from 'react';

const ComingSoon = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center">
      <h1 className="text-5xl font-bold text-gray-800 mb-4">Coming Soon</h1>
      <p className="text-xl text-gray-600 mb-8">We are working hard to bring you this feature. Stay tuned!</p>
    </div>
  );
};

export default ComingSoon;
